import { render, staticRenderFns } from "./NFTs.vue?vue&type=template&id=ff341f56&scoped=true"
import script from "./NFTs.vue?vue&type=script&lang=js"
export * from "./NFTs.vue?vue&type=script&lang=js"
import style0 from "./NFTs.vue?vue&type=style&index=0&id=ff341f56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff341f56",
  null
  
)

export default component.exports